{
  "CSAT": {
    "TITLE": "Beoordeel uw gesprek",
    "PLACEHOLDER": "Vertel ons meer...",
    "RATINGS": {
      "POOR": "😞 Slecht",
      "FAIR": "😑 Redelijk",
      "AVERAGE": "😐 Gemiddeld",
      "GOOD": "😀 Goed",
      "EXCELLENT": "😍 Uitstekend"
    }
  }
}
